import { Type } from 'class-transformer';

// Use the types from device-management.ts for consistency
export { IInventoryListResponse, IInventoryQueryDto, IInventoryResponse, Inventory, IPostInventoryBodyDto } from './device-management';

// Legacy support - keeping old field names for backward compatibility
export class LegacyInventory {
  id: number;

  // Legacy fields
  cihazTip?: string;
  marka?: string;
  model?: string;
  cihazDurumu?: string;
  kimeZimmetli?: string | number;
  hafiza?: string;
  imei1?: string;
  imei2?: string;
  serino?: string;
  aciklama?: string;

  @Type(() => Date)
  zimmetTarihi?: Date;

  @Type(() => Date)
  urunStokGirisiTarihi?: Date;

  @Type(() => Date)
  createdAt?: Date;

  @Type(() => Date)
  updatedAt?: Date;
}
